import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_FUND_DISTRIBUTOR_PRODUCTS_LIST_API_ID =
  'FETCH_INVESTCORE_FUND_DISTRIBUTOR_PRODUCTS_LIST_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_FUND_DISTRIBUTOR_PRODUCTS_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/fund-distributor-products`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
